<div *ngIf="zeiterfassungAktiv">
  <!-- Einfach -->
  <div *ngIf="isAnsichtEinfach">
    <div class="section" [class.zeiterfassungAktiv]="auftrag.zeiterfassungLaeuft" [class.zeiterfassungInaktiv]="!auftrag.zeiterfassungLaeuft">
      <div *ngIf="auftrag.zeiterfassungLaeuft" class="tour-aktiv">
        <h1>{{ 'Zeiterfassung läuft' | translate }}: {{ aktiveZeit | async }}</h1>
      </div>

      <div *ngIf="!auftrag.zeiterfassungLaeuft" class="tour-pause">
        <h1>{{ 'Zeiterfassung' | translate }}: {{ aktiveZeit | async }}</h1>
      </div>

      <div class="" *ngIf="isBearbeitenErlaubt">
        <ion-button color="light" appClick (clicked)="onStart()" class="start-button" [disabled]="auftrag.zeiterfassungLaeuft">
          <ion-icon name="play"></ion-icon> Start
        </ion-button>

        <ion-button color="light" appClick (clicked)="onPause()" class="pause-button" [disabled]="!auftrag.zeiterfassungLaeuft">
          <ion-icon name="pause"></ion-icon> Pause
        </ion-button>

        <ion-button color="light" appClick (clicked)="onBearbeiten()" class="manuell-button" *ngIf="manuellBearbeitenErlaubt">
          <ion-icon name="create"></ion-icon> Manuell
        </ion-button>

        <!-- <ion-button size="large" color="light" appClick (clicked)="onEnde()" class="ende-button">
          <ion-icon name="stop"></ion-icon> Ende
        </ion-button> -->
      </div>
    </div>
  </div>

  <!-- Mit Art -->
  <div *ngIf="isAnsichtMitArt">
    <div class="section">
      <div *ngIf="zeiterfassungLaeuft" class="tour-aktiv">
        <h1>{{ 'Zeiterfassung läuft' | translate }}</h1>
      </div>

      <div *ngIf="!zeiterfassungLaeuft" class="tour-pause">
        <h1>{{ 'Zeiterfassung' | translate }}</h1>
      </div>

      <ion-list>
        <ion-item *ngFor="let p of arbeitszeitenList" appClick (clicked)="onArbeitszeitSelected(p)" [detail]="false" [style]="domSanitizer.bypassSecurityTrustStyle(p.style)">
          <ion-label>
            <div>{{ p.name }}</div>
            <p *ngIf="p.bemerkung" class="bemerkung">
              {{ p.bemerkung }}
            </p>

            <p *ngIf="p.bemerkungErforderlich" class="bemerkung-erforderlich">
              {{ 'Bemerkung erforderlich' | translate }}
            </p>
          </ion-label>

          <!-- Nicht aktiv -->
          <ion-label slot="end" *ngIf="!p.laeuft">
            <span class="">{{ p.aktiveZeit }}</span>
          </ion-label>

          <!-- Aktiv / Zeiterfasssung läuft.-->
          <ion-label slot="end" *ngIf="p.laeuft">
            <span class="laufende-zeit">{{ p.aktiveZeit }}</span>

            <ion-button size="large" color="light" appClick (clicked)="onEnde()" class="list-action-button ende-button">
              <ion-icon name="stop"></ion-icon>
            </ion-button>
          </ion-label>
        </ion-item>
      </ion-list>

      <div class="" *ngIf="isBearbeitenErlaubt && !zeiterfassungLaeuft">
        <ion-button color="light" appClick (clicked)="onStart()" class="start-button">
          <ion-icon name="play"></ion-icon> Start
        </ion-button>

        <!-- <ion-button color="light" appClick (clicked)="onPause()" class="pause-button" [disabled]="!auftrag.zeiterfassungLaeuft">
          <ion-icon name="pause"></ion-icon> Pause
        </ion-button> -->
      </div>
    </div>
  </div>



</div>

<!-- Hidden Select-Box zur Auswahl der Arbeitszeit-Art -->
<ion-select #artWaehlenSelect [hidden]="true" (ionChange)="onArbeitszeitArtSelected($event)" [multiple]="false" [okText]="'OK' | translate" [cancelText]="'Abbrechen' | translate" interface="action-sheet" mode="ios">
  <ion-label>Art</ion-label>
  <ion-select-option *ngFor="let p of arbeitszeitArtenListe" [value]="p" [class.arbeitszeitart-standard]="p.Standard" [class.arbeitszeitart-other]="!p.Standard">{{ p.Name }}</ion-select-option>
</ion-select>